import { render, staticRenderFns } from "./device-details-modal.vue?vue&type=template&id=f28f052c&scoped=true"
import script from "./device-details-modal.vue?vue&type=script&lang=js"
export * from "./device-details-modal.vue?vue&type=script&lang=js"
import style0 from "./device-details-modal.vue?vue&type=style&index=0&id=f28f052c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28f052c",
  null
  
)

export default component.exports